import VGrid from './VGrid';
import './VGrid.scss';

export default VGrid('grid-row');
